import {accessTokenName, getAuthorizationHeaderValue, redirectToLoginPage} from "@/interceptors/common";

/**
 * Adds interceptor before sending a request (adds access token to all request)
 * @param {*} request request
 * @returns axios request
 */
export const addTokenToRequestInterceptorAsync = async (request: any) => {
    const accessToken = localStorage.getItem(accessTokenName);
    if (accessToken) {
        request.headers.Authorization = getAuthorizationHeaderValue(accessToken);
    }
    return request;
}

/**
 * Adds interceptor after receiving response from HdService. Adds new access token if response status code equal 401 and send request again
 * @param {*} error axios response error
 * @returns axios request
 */
export const responseInterceptorAsync = async (error: any): Promise<any> => {
    if (error.config && error.response && error.response.status === 401) {
        localStorage.removeItem(accessTokenName);
        redirectToLoginPage();
        return ;
    }
    return Promise.reject(error);
}